/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto } from '../models/Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto';
import type { Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsDto } from '../models/Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TwoFactorConfigurationService {

    /**
     * @returns Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiTwoFactorConfigurationIsTwoFactorEnabled(): CancelablePromise<Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/two-factor-configuration/is-two-factor-enabled',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionId 
     * @returns Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiTwoFactorConfigurationEnableTwoFactor(
optionId?: number,
): CancelablePromise<Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/two-factor-configuration/enable-two-factor',
            query: {
                'optionId': optionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiTwoFactorConfigurationDisableTwoFactor(): CancelablePromise<Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/two-factor-configuration/disable-two-factor',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiTwoFactorConfigurationTwoFactorAuthenticationOptions(): CancelablePromise<Array<Wealthlane_Dtos_LoginSecurityOptions_LoginSecurityOptionsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/two-factor-configuration/two-factor-authentication-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
